/* istanbul ignore file */
import { MainViewId } from "./constants/general";
import { Controllers } from "./controllers";
import { FooterController } from "./controllers/footer";
import { HeaderController } from "./controllers/header";

import "./index.scss";
import { CloakService } from "./services/cloakService";

document.addEventListener("DOMContentLoaded", () => {
	CloakService.DeCloak();
});

CloakService.Ready().then(() => {
	const headerController = new HeaderController();
	headerController.Init();

	const footerController = new FooterController();
	footerController.Init();

	const viewElement = document.getElementById(MainViewId);
	if (viewElement == null) {
		throw new Error(`View [${MainViewId}] not found`);
	}

	const controllerTypeName = viewElement.dataset.controller;
	if (!controllerTypeName) {
		throw new Error("Controller type not found in the main view");
	}

	const controllerType = Controllers[controllerTypeName];
	if (controllerType != null) {
		const currentController = new controllerType();
		currentController.Init();
	}
	else {
		throw new Error(`Controller [${controllerTypeName}] not found`);
	}
});
